import { FC } from "react";

interface PageSizeSelectorProps {
  pageSize: number;
  setPageSize: (size: number) => void;
}

const PageSizeSelector: FC<PageSizeSelectorProps> = ({
  pageSize,
  setPageSize,
}) => {
  return (
    <div className="flex items-center">
      <select
        id="pageSize"
        value={pageSize}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setPageSize(Number(e.target.value))}
        className="px-2 py-1 border rounded"
      >
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={50}>50</option>
      </select>
    </div>
  );
};

export default PageSizeSelector;
